<div class="calculator-inputs-page col-md-6">
  <div class="glass-card calculator-card p-3 p-md-4">

    <!-- Header -->
    <div class="d-flex align-items-center justify-content-between mb-3 calc-card-header">
      <div class="d-flex align-items-center gap-2">
        <i :class="ui_config.header_icon_class" class="text-white opacity-75 calc-header-icon"></i>

        <div class="d-flex flex-column">
          <div class="text-white fw-semibold lh-1 small">
            {{ ui_labels.card_title }}
          </div>
          <div class="text-white-50 small">
            Adjust inputs to model outcomes
          </div>
        </div>
      </div>
    </div>

    <form @submit.prevent="submit_calculator_inputs" class="vstack gap-3 calc-form">

      <!-- INVESTMENT AMOUNT -->
      <div class="calc-section">
        <div class="d-flex align-items-center justify-content-between mb-2">
          <label class="form-label mb-0 text-white-50 small fw-semibold">
            {{ ui_labels.investment_amount }}
          </label>
          <span class="text-white-50 small">ZAR</span>
        </div>

        <div class="input-group input-group-sm calc-input-group">
          <span class="input-group-text bg-transparent text-white-50 border-secondary calc-addon">
            {{ currency_symbol }}
          </span>
          <input
            type="text"
            class="form-control bg-transparent text-white border-secondary fw-semibold calc-control"
            :value="formatted_investment_amount"
            @input="handle_investment_amount_input"
            inputmode="numeric"
            required
          />
        </div>

        <div class="d-flex gap-2 mt-2 flex-wrap">
          <button
            v-for="preset in investment_amount_presets"
            :key="preset.value"
            type="button"
            class="btn btn-sm rounded-3 px-3 py-1 border calc-chip"
            :class="preset.value === investment_amount
              ? 'btn-warning text-dark border-warning'
              : 'btn-outline-light border-secondary text-white-50'"
            @click="set_investment_amount(preset.value)"
          >
            <span class="small fw-semibold">{{ preset.label }}</span>
          </button>
        </div>
      </div>

      <hr class="border-secondary opacity-25 my-1 calc-divider">

      <!-- PROVINCE -->
      <div class="calc-section">
        <label class="form-label mb-2 text-white-50 small fw-semibold">
          {{ ui_labels.province }}
        </label>

        <select
          class="form-select form-select-sm bg-transparent text-white border-secondary calc-select"
          v-model="selected_province"
          required
        >
          <option
            v-for="province in provinces"
            :key="province.value"
            :value="province.value"
            class="text-dark"
          >
            {{ province.label }}
          </option>
        </select>
      </div>

      <hr class="border-secondary opacity-25 my-1 calc-divider">

      <!-- ASSET MIX -->
      <div class="calc-section">
        <div class="d-flex align-items-center justify-content-between mb-2">
          <label class="form-label mb-0 text-white-50 small fw-semibold">
            {{ ui_labels.asset_mix }}
          </label>

          <span
            class="badge rounded-pill border mix-badge"
            :class="asset_mix_total === 100
              ? 'bg-success-subtle text-success border-success-subtle'
              : 'bg-warning-subtle text-warning border-warning-subtle'"
          >
            <span class="small fw-semibold">{{ asset_mix_total }}%</span>
          </span>
        </div>

        <div class="vstack gap-2">
          <div
            v-for="asset in assets"
            :key="asset.key"
            class="d-flex align-items-center justify-content-between gap-2 p-2 rounded-3 border border-secondary border-opacity-25 asset-row"
          >
            <div class="d-flex align-items-center gap-2 flex-grow-1 min-w-0">
              <div class="rounded-3 d-flex align-items-center justify-content-center border border-secondary border-opacity-25 p-2 asset-icon">
                <span class="small">{{ asset.icon }}</span>
              </div>

              <div class="text-white small fw-semibold text-truncate">
                {{ asset.label }}
              </div>
            </div>

            <div class="d-flex align-items-center gap-2">
              <input
                class="form-range m-0 calc-range"
                type="range"
                min="0"
                max="100"
                step="1"
                :value="asset_mix[asset.key]"
                @input="handle_asset_mix_input(asset.key, $event)"
              />

              <div class="text-white-50 small fw-semibold text-end mix-value">
                {{ asset_mix[asset.key] }}%
              </div>
            </div>
          </div>
        </div>

        <div v-if="asset_mix_total !== 100" class="mt-2 small text-warning">
          <i class="bi bi-exclamation-triangle me-1"></i>
          {{ ui_labels.asset_mix_warning }} <span class="fw-semibold">100%</span>.
          {{ ui_labels.you_are_at }} <span class="fw-semibold">{{ asset_mix_total }}%</span>
        </div>
      </div>

      <hr class="border-secondary opacity-25 my-1 calc-divider">

      <!-- COHORT PRIORITIES -->
      <div class="calc-section">
        <label class="form-label mb-2 text-white-50 small fw-semibold">
          {{ ui_labels.cohort_priorities }}
        </label>

        <div class="d-flex gap-2 flex-wrap">
          <button
            v-for="cohort in cohort_options"
            :key="cohort.key"
            type="button"
            class="btn btn-sm rounded-pill px-3 py-1 border fw-semibold calc-pill"
            :class="is_cohort_enabled(cohort.key)
              ? cohort.enabled_class
              : 'btn-outline-custom'"
            @click="toggle_cohort(cohort.key)"
          >
            <span class="small">{{ cohort.label }}</span>
            <span class="small ms-1 opacity-75">{{ cohort.bonus_label }}</span>
          </button>
        </div>
      </div>

    </form>
  </div>
</div>